export const TagsOption = [
  {
    id: 1,
    label: '大箱',
    value: 'Large box',
  },
  {
    id: 2,
    label: '在籍多い',
    value: 'Many students',
  },
  {
    id: 3,
    label: '口コミ多数',
    value: 'reviews Many',
  },
  {
    id: 4,
    label: '予約殺到中',
    value: 'inundated with reservations',
  },
  {
    id: 5,
    label: '明朗会計',
    value: 'Clear Accounting',
  },
  {
    id: 6,
    label: '初回案内が丁寧',
    value: 'First Proposal',
  },
];
